module.exports = __webpack_public_path__ + "img/8194AB_D6DFEB_C0CEDE_B0BFD1-256px.7f42b921.png";